// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"91027762","381":"91b7fd2e","782":"91b7fd2e","835":"a81db3bf","861":"f0862322","865":"91027762"}[chunkId] + ".chunk.css";
};